// extracted by mini-css-extract-plugin
module.exports = {"officialMediaModalRoot":"index-officialMediaModalRoot-33_O2"};